<template>
	<div class="row flexible-content-block">
		<div v-bind:class="[columnClasses.wide]">
			<img v-bind:src="data.image.src" v-bind:alt="data.image.alt" v-bind:class="{nomargin: data.caption }" class="centered" />
			<figcaption v-if="data.caption" v-html="data.caption"></figcaption>
		</div>
	</div>
</template>

<style lang="scss">
    @import "../../../../styles/scss/component/wysiwyg/image";
</style>

<script>
export default {
	props: ['data', 'columnClasses']
}
</script>